import { Skeleton } from '@patternfly/react-core';
import { randomizeWidth } from 'helpers/ui';
import React from 'react';

const ItemSkeleton = () => (
  <div className="upcoming-events__evt upcoming-events__evt--skeleton">
    <Skeleton
      height="20px"
      width={`${randomizeWidth(200, 50)}px`}
      screenreaderText="Loading small rectangle contents"
    />
    <Skeleton
      height="20px"
      width={`${randomizeWidth(100, 40)}px`}
      screenreaderText="Loading small rectangle contents"
    />
    <Skeleton
      height="16px"
      width={`${randomizeWidth(50, 50)}px`}
      screenreaderText="Loading small rectangle contents"
    />

    <Skeleton
      className="upcoming-events__evt-status upcoming-events__evt-status--skeleton"
      height="16px"
      width="16px"
      screenreaderText="Loading small rectangle contents"
    />
  </div>
);

export default React.memo(ItemSkeleton);
